const BAD_REQUEST_ERROR_CODE = 400;
const UNAUTHORIZED_ERROR_CODE = 401;
const ACCESS_FORBIDDEN_ERROR_CODE = 403;
const NOT_FOUND_ERROR_CODE = 404;

const INTERNAL_SERVER_ERROR_CODE = 500;
const NO_INTERNET_ERROR_CODE = 503;

const INVALID_TOKEN = 'INVALID_TOKEN';

const INVALID_USER = 'INVALID_USER';

const NOT_AUTHORIZED_EXCEPTION = 'NotAuthorizedException';

const USER_NOT_FOUND_EXCEPTION = 'UserNotFoundException';

const INVALID_SESSION_TOKEN = 'INVALID_SESSION_TOKEN';

const REQUEST_TIMED_OUT = 'Endpoint request timed out';

const INVALID_CREDENTIALS = 'INVALID_CREDENTIALS';

const DB_MAINTENANCE_ERROR = 'DB_MAINTENANCE_ERROR';

const INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR';

const SERVER_UNDER_MAINTENANCE = 'SERVER_UNDER_MAINTENANCE';

export const resStatuses = {
  invalidToken: INVALID_TOKEN,
  invalidUser: INVALID_USER,
  notAuthorizedException: NOT_AUTHORIZED_EXCEPTION,
  userNotFoundException: USER_NOT_FOUND_EXCEPTION,
  invalidSessionToken: INVALID_SESSION_TOKEN,
  requestTimedOut: REQUEST_TIMED_OUT,
  invalidCredentials: INVALID_CREDENTIALS,
  dbMaintenanceError: DB_MAINTENANCE_ERROR,
  internalServerError: INTERNAL_SERVER_ERROR,
  serverUnderMaintenance: SERVER_UNDER_MAINTENANCE,
  refreshTokenExpired: 'REFRESH_TOKEN_EXPIRED'
};

export const statusCodes = {
  internalServerErrorCode: INTERNAL_SERVER_ERROR_CODE,
  noInternetErrorCode: NO_INTERNET_ERROR_CODE,
  badRequestErrorCode: BAD_REQUEST_ERROR_CODE,
  unAuthorizedErrorCode: UNAUTHORIZED_ERROR_CODE,
  accessForbiddenErrorCode: ACCESS_FORBIDDEN_ERROR_CODE,
  notFoundErrorCode: NOT_FOUND_ERROR_CODE
};

export const EMAIL_NOT_REGISTERED = 'ACCOUNT_DOES_NOT_EXISTS_FOR_GIVEN_EMAIL';
export const PHONE_NUMBER_NOT_REGISTERED = 'NOT_REGISTERED_USER';

export const PHONE_NUMBER_NOT_VERIFIED = 'PHONE_NUMBER_NOT_VERIFIED';

export const USER_HAS_NO_ACCESS_EXCEPTION = 'USER_HAS_NO_ACCESS_EXCEPTION';

export const USER_ALREADY_REGISTERED = 'USER_ALREADY_REGISTERED_FOR_PRODUCT';

export const ACCOUNT_DOES_NOT_EXISTS_FOR_GIVEN_EMAIL =
  'ACCOUNT_DOES_NOT_EXISTS_FOR_GIVEN_EMAIL';

export const CAN_NOT_MARK_SUCCESS_FOR_PAYMENT_SUCCESS_ORDER =
  'CAN_NOT_MARK_SUCCESS_FOR_PAYMENT_SUCCESS_ORDER';

export const NO_IN_PROGRESS_ORDERS_FOUND_FOR_USER =
  'NO_IN_PROGRESS_ORDERS_FOUND_FOR_USER';

export const PRODUCT_PURCHASE_ELIGIBILITY_DID_NOT_MATCH =
  'PRODUCT_PURCHASE_ELIGIBILITY_DID_NOT_MATCH';

export const PRODUCT_EXPIRED = 'PRODUCT_EXPIRED';

export const EMAIL_NOT_VERIFIED = 'EMAIL_NOT_VERIFIED';

export const EMAIL_MISS_MATCH = 'EMAIL_MISS_MATCH';

export const PRODUCT_IS_NOT_ACTIVE = 'PRODUCT_IS_NOT_ACTIVE';

export const USER_ALREADY_PAID_FOR_PARTIAL_PRODUCT_CODE =
  'USER_ALREADY_PAID_FOR_PARTIAL_PRODUCT_CODE';

export const USER_ALREADY_PAID_FOR_PRODUCT_CODE =
  'USER_ALREADY_PAID_FOR_PRODUCT_CODE';

export const NUMBER_OF_REGISTRATIONS_LIMIT_EXCEEDED =
  'NUMBER_OF_REGISTRATIONS_LIMIT_EXCEEDED';

export const INVALID_PRODUCT_CODE = 'INVALID_PRODUCT_CODE';

export const PRODUCT_CONFIG_DOES_NOT_EXISTS = 'PRODUCT_CONFIG_DOES_NOT_EXISTS';

export const errorEnums = {
  invalidProductCode: INVALID_PRODUCT_CODE,
  productConfigDoesNotExists: PRODUCT_CONFIG_DOES_NOT_EXISTS
};

export const USER_BANK_ACCOUNT_DETAILS_DOES_NOT_EXIST =
  'USER_BANK_ACCOUNT_DETAILS_DOES_NOT_EXIST';

export const USER_PAN_CARD_DETAILS_DOES_NOT_EXIST =
  'USER_PAN_CARD_DETAILS_DOES_NOT_EXIST';

export const USER_AADHAR_ADDRESS_DETAILS_DOES_NOT_EXIST =
  'USER_AADHAR_ADDRESS_DETAILS_DOES_NOT_EXIST';

export const EMAIL_ALREADY_LINKED = 'EMAIL_ALREADY_LINKED';

export const BROWSER_SESSION_ID_NOT_FOUND_IN_HEADERS =
  'BROWSER_SESSION_ID_NOT_FOUND_IN_HEADERS';

export const INVALID_REQUEST_SIGNATURE = 'INVALID_REQUEST_SIGNATURE';
